import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {PhoneType} from "../constants/offer_notification_chatbot_form";

enum WhatsAppGTMEvent {
    POPUP_VIEW = "whatsapp_popup_view",
    SIGN_UP = "whatsapp_popup_sign_up"
}

export const hitGtmWhatsAppPopupView = () => {
    hitGoogleTagManager({
        event: WhatsAppGTMEvent.POPUP_VIEW
    });
};

export const hitGtmAddToCompareClick = (type: PhoneType) => {
    hitGoogleTagManager({
        event: WhatsAppGTMEvent.SIGN_UP,
        whatsapp_method: type === PhoneType.Whatsapp ? "whatsapp" : "sms"
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {PhoneType} from "../constants/offer_notification_chatbot_form";

enum WhatsAppGTMEvent {
    POPUP_VIEW = "whatsapp_popup_view",
    SIGN_UP = "whatsapp_popup_sign_up"
}

export const hitGtmWhatsAppPopupView = () => {
    hitGoogleTagManager({
        event: WhatsAppGTMEvent.POPUP_VIEW
    });
};

export const hitGtmAddToCompareClick = (type: PhoneType) => {
    hitGoogleTagManager({
        event: WhatsAppGTMEvent.SIGN_UP,
        whatsapp_method: type === PhoneType.Whatsapp ? "whatsapp" : "sms"
    });
};
